import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Client from "../utils/client";
import { motion, AnimatePresence } from "framer-motion";
import { api_url } from "../constant";
import { toast } from "react-toastify";
import { FeedbackIcon } from "../icons/feedback";
import { exit_icon } from "../icons/exit";
import { Link, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { getCategories, getCitiesByState, getStates } from "../api";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../store/authProvider";


const ConsultationForm = ({ showForm, setShowForm }) => {
  const [succeeded, setSucceeded] = useState(false);
  const [options, setOptions] = useState(true);
  const [type, setType] = useState("");
  const [media, setMedia] = useState("");
  const { register, handleSubmit, getValues, reset } = useForm();
  const {isAuth} = useAuth();
  const navigate = useNavigate();

  const { data: subCategories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    initialData: [],
  });
  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const { data: cities, refetch: citiesRefetch } = useQuery({
    queryKey: ["cities"],
    queryFn: () => getCitiesByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const onSubmit = async (data) => {
    const _data = {
      type,
      state: data.state.value,
      city: data.city.value,
      subCategory_id: data.subCategory_id.value,
      description: data.description,
      image: media,
    };
    await Client.post(api_url + "/consultation", _data)
      .then((res) => setSucceeded(true))
      .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
  };

  const upload = async (e) => {
    var formData = new FormData();
    formData.append("image", e);
    const url = "https://api.mahsool.sd/image/upload";
    const response = await fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token").split('"')[1],
      },
    }).then((res) => res.json());
    setMedia(response.url);
  };

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          dir="rtl"
          className="border-primary  text-start relative rounded-3xl transition-all border shadow-2xl w-full lg:w-auto px-6 py-8 bg-white flex flex-col gap-3 backdrop-blur-lg"
        >
          <div
            className="text-red-600 w-7 absolute top-3 left-3 hover:scale-110 cursor-pointer "
            onClick={() => setShowForm(false)}
          >
            {exit_icon}
          </div>
          <AnimatePresence>
            {succeeded ? (
              <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.2 }}
                className=" transition-all text-center flex justify-center items-center flex-col gap-8"
              >
                <h1 className="text-2xl font-bold">
                  تم إستلام طلبك سيتم التواصل معك في اقرب وقت :)
                </h1>
                <div className=""> {FeedbackIcon}</div>
              </motion.div>
            ) : (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="flex flex-col gap-4 "
              >
                <div className="font-bold flex flex-col gap-3">
                  <p className="text-sm">طريقة التواصل : </p>
                  <div className="flex gap-3">
                    <div
                      className={`min-w-fit border-primary border p-1 text-sm rounded-md px-3 hover:cursor-pointer transition-all duration-300 ${
                        type === "visit" ? "text-white bg-primary" : ""
                      }`}
                      onClick={() => setType("visit")}
                    >
                      زيارة المختص
                    </div>
                    <div
                      className={`min-w-fit border-primary border p-1 text-sm rounded-md px-3 hover:cursor-pointer transition-all duration-300 ${
                        type === "phone call" ? "text-white bg-primary" : ""
                      }`}
                      onClick={() => setType("phone call")}
                    >
                      مكالمة هاتفية
                    </div>
                  </div>
                </div>

                <ReactSelect
                  className=""
                  options={subCategories.map((e) => {
                    return { label: e.name, value: e.id };
                  })}
                  value={getValues().subCategory_id}
                  onChange={(value) =>
                    reset({ ...getValues(), subCategory_id: value })
                  }
                  hideSelectedOptions={false}
                  closeMenuOnSelect={true}
                  isRtl
                  styles={dropdownStyles}
                  placeholder={"المحصول"}
                />
                <ReactSelect
                  options={states.map((e) => {
                    return { label: e.name, value: e.id };
                  })}
                  value={getValues().state}
                  onChange={(value) => {
                    reset({ ...getValues(), state: value });
                    citiesRefetch();
                  }}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={true}
                  styles={dropdownStyles}
                  isRtl
                  placeholder={"الولاية"}
                />
                <ReactSelect
                  options={cities.map((e) => {
                    return { label: e.name, value: e.id };
                  })}
                  value={getValues().city}
                  onChange={(value) => reset({ ...getValues(), city: value })}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={true}
                  styles={dropdownStyles}
                  isRtl
                  placeholder={"المدينة"}
                  isDisabled={cities.length === 0}
                />

                <textarea
                  type="text"
                  className="border-secondary border rounded-md placeholder:text-base max-h-24 "
                  placeholder="وصف الإستشارة"
                  {...register("description", { required: true })}
                />
                <div className="w-full h-16 border-secondary border-[1px] bg-gray-50 rounded-md flex justify-center items-center text-gray-500">
                  <input
                    type="file"
                    id="file"
                    className="hidden"
                    onChange={(e) => upload(e.target.files[0])}
                  />

                  <label htmlFor="file" className="font-bold text-sm">
                    إرفق صورة
                  </label>
                </div>
                <div className="flex justify-center ">
                  {media && <img src={media} className="w-20 rounded-lg" />}
                </div>
                <button
                  type="submit"
                  className="rounded-full bg-primary text-white w-1/3 h-9 mx-auto font-bold hover:scale-110 transition transform"
                >
                  إرسال
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </form>
    </div>
  );
};

export default ConsultationForm;

const dropdownStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? "green" : "#A7DDB6",
    borderRadius: "6px",
    height: "30px",
    paddingLeft: "8px",
    paddingRight: "8px",
    fontWeight: "300",
    boxShadow: state.isFocused ? "none" : "none",
    "&:hover": {
      boxShadow: "none",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: " #23AA49",
  }),
};
